import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const testEmployerUpdatedWebhook = (axios: IAxiosInstance) => {
  return async ({
    employerUpdatedWebhook,
    userType,
    test,
    usePrimary,
  }: ISchema["#/definitions/ITestEmployerUpdatedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ITestEmployerUpdatedWebhookResponse"]
    >(`/api/testEmployerUpdatedWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      employer_update_webhook: employerUpdatedWebhook,
      user_type: userType,
      test,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
